import CryptoJS from 'crypto-js';
import { btoa, atob, showAlert } from '../../lib/helpers';
import { dataIntervalExport } from '../params';
import { postApi } from '../../lib/fetcher';

const inputerAggregatorSettlementTransaction = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      insertProgress: 0,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      totalPage: 0,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data.data;
    },

    setCategory(state, data) {
      state.allCategory = data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'rrn'} ${sort}`;

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/report/inputer-aggregator-transaction/settlement`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getDetail(ctx, { trx_id, date }) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        trx_id,
        version: btoa(
          CryptoJS.SHA256(
            trx_id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/report/inputer-aggregator-transaction/view-settlement`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setItem', { payload: responseData });
      }
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      if (ctx.rootState.isExport) {
        showAlert(ctx, 'Export in progress !', 'mdi-alert', 'red');

        return;
      }

      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        showAlert(ctx, 'Export Failed !', 'mdi-alert', 'red');

        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/export-settlement-inputer-transaction/aggregator`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        if (responseData.data.message != null) {
          showAlert(ctx, responseData.data.message, 'mdi-alert', 'red');
          ctx.commit('setIsExport', false, { root: true });
          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: 'export-settlement-inputer-transaction',
            },
            { root: true }
          );
        }, dataIntervalExport);
        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },
  },
};
export default inputerAggregatorSettlementTransaction;
